var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '@anwb/icon';
import { ButtonIconContainer } from './styles/button.styled';
export const ButtonIcon = (_a) => {
    var { className, icon, variant = 'on-light', dataTest = `button-${variant}`, type = 'button', color } = _a, props = __rest(_a, ["className", "icon", "variant", "dataTest", "type", "color"]);
    return (React.createElement(ButtonIconContainer, Object.assign({ "$variant": variant, "$color": color, className: className, "data-test": dataTest, type: type }, props),
        React.createElement(Icon, { variant: icon, size: "lg" })));
};
//# sourceMappingURL=ButtonIcon.js.map